import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchPromotionTypes, deletePromotionType } from "actions/promotionType";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class PromotionTypeIndex extends Component {
  componentDidMount() {
    this.props.fetchPromotionTypes();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchPromotionTypes({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { promotionTypeURL: promotionType_url } = this.props.match.params;
    this.props.fetchPromotionTypes({ promotionType_url, page, ...this.search });
  };

  handlePromotionTypeDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deletePromotionTypeProcess(id);
      },
      title: "Delete promotionType",
      body: "Are you sure you want to delete this promotionType?"
    });
  };

  deletePromotionTypeProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deletePromotionType, match } = this.props;
    const { promotionTypeURL: promotionType_url } = match.params;
    deletePromotionType(id, { promotionType_url })
      .then(() => {
        this.props.fetchPromotionTypes({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete PromotionType Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { promotionTypes } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table promotionTypes={promotionTypes} onClickDelete={this.handlePromotionTypeDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={promotionTypes.current_page}
            lastPage={promotionTypes.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authPromotionType, promotionTypes, confirmationPopupActive }) => ({
  authPromotionType,
  promotionTypes,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchPromotionTypes, deletePromotionType, toggleconfirmationPopup, toggleNotification }
)(PromotionTypeIndex);



// WEBPACK FOOTER //
// ./src/pages/PromotionType/Index/index.js